import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import agent from '../../../app/api/agent';
import { MetaDataElement } from '../../../app/models/metaDataConfig';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import FormComponentDyDb from './FormComponent';
import { useStore } from '../../../app/stores/store';
import { IFormDetails } from '../../../app/stores/dashboardConfiguration/types';
import './styles.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { masterElementType } from './type';
import { commSettingsForDynDash } from '../../../app/stores/CommunicationSettingForDynamicDashboard/service';

function FormRegisterDyDB({
  type,
  style,
  name,
  masterId,
  setIsTableUpdated,
  metaData = [],
  cancelBtnMode,
  submitBtnMode,
  automaticPdf = false,
  selectedValue,
  linkColumnName,
}: {
  type?: string;
  selectedValue?: string;
  style?: any;
  permission: number;
  name: string;
  masterId: string;
  index: number;
  setIsTableUpdated: Dispatch<SetStateAction<boolean>>;
  flexBasis?: string;
  metaData: masterElementType[];
  cancelBtnMode: number;
  submitBtnMode: number;
  automaticPdf: boolean;
  linkColumnName?: string;
}) {
  const {
    userStore,
    DashboardConfigurationStore,
    commonStore,
    DynamicDashboardStore: { staticSelectedCard, assignUserMaster },
  } = useStore();
  const { user, DepartmentNameAddMarkLogin } = userStore;
  const { GETMasterMetaData } = DashboardConfigurationStore;
  const [formDetails, setFormDetails] = useState<
    MetaDataElement[] | IFormDetails[]
  >([]);
  const [loader, setLoader] = useState({
    content: false,
    submit: false,
  });

  useEffect(() => {
    DepartmentNameAddMarkLogin();
    // eslint-disable-next-line
  }, []);

  // const defaultForm = useRef<MetaDataElement[]>([]);

  const getForm = async () => {
    setLoader((p) => ({
      ...p,
      content: true,
    }));
    let result: any = [];
    // if (metaData.length === 0) {
    if (masterId !== '') {
      result = await GETMasterMetaData(masterId);
    }
    // }
    // else {
    //   const payload = {
    //     masterId,
    //     ids:
    //       metaData
    //         // ?.filter((data) => data.mode !== 2)
    //         .map((meta) => meta.elementId) || [],
    //   };
    //   result = await agent.newMasterReport.getMasterMetaDataBasedOnID(payload);
    // }
    if (result) {
      // defaultForm.current = result.data;
      if (metaData.length === 0) {
        setFormDetails(result);
      } else {
        let metaDataIDs = metaData?.map((data: any) => data.elementId);
        const tempMetaData: any[] = [];
        result?.forEach((dataFromAPI: any) => {
          if (metaDataIDs.includes(dataFromAPI.elementId)) {
            const findMetaDataById = metaData.find(
              (m) => m.elementId === dataFromAPI.elementId,
            );
            tempMetaData.push({
              ...dataFromAPI,
              mode: findMetaDataById?.mode,
              dependency: findMetaDataById?.dependency,
            });
          } else {
            tempMetaData.push({
              ...dataFromAPI,
              mode: 0,
              dependency: undefined,
            });
          }
        });
        setFormDetails(tempMetaData);
      }
    }
    // if (reset) {
    //   let metaDataList: IFormDetails[] = await GETMasterMetaData(masterId);
    //   const tempMetaData: any[] = [];
    //   metaData?.forEach((data) => {
    //     metaDataList?.forEach((dataFromAPI) => {
    //       if (data.elementId === dataFromAPI.elementId) {
    //         tempMetaData.push({
    //           ...dataFromAPI,
    //           mode: data?.mode !== undefined ? data?.mode : 1,
    //         });
    //       }
    //     });
    //   });
    //   setFormDetails(tempMetaData);
    // } else {
    //   setFormDetails(metaData);
    // }
    setLoader((p) => ({
      ...p,
      content: false,
    }));
  };

  useEffect(() => {
    getForm();
    // eslint-disable-next-line
  }, [masterId]);

  const downloadPDF = async (
    updatedFormDetails: any[],
    headerImage?: string,
  ) => {
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'portrait'; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    // const title = 'Delivery Report';
    const headers = [['Title', 'Values']];

    const data: any[][] = [];
    const imageURL = headerImage ? headerImage : '/assets/logo.png';
    doc.addImage(imageURL, 'PNG', marginLeft, 40, 500, 80);

    // data.push(['Serial No.', assetId]);

    metaData?.forEach((metDt) => {
      updatedFormDetails.forEach((dataFromAPI) => {
        if (metDt.elementId === dataFromAPI.elementId) {
          if (metDt.mode !== 2) {
            let values = [];
            let splitValue;
            if (dataFromAPI.elementValue?.includes('DynamicTable|')) {
              const stringData =
                dataFromAPI.elementValue?.split('DynamicTable|')?.[1];
              let tempValue =
                stringData !== undefined ? JSON.parse(stringData) : [];
              const rowsList: string[] = [];
              let columnHeaders: string[] = Object.keys(tempValue[0]);
              tempValue?.forEach((val: any) => {
                let rowVal = '';
                columnHeaders?.forEach((header: string, index: number) => {
                  if (header !== '_uuid_') {
                    rowVal += header?.split('_')?.join(' ');
                    rowVal += ': ';
                    rowVal += val?.[header];
                    if (index !== columnHeaders.length - 1) {
                      rowVal += ', ';
                    }
                  }
                });
                rowsList.push(rowVal);
              });
              splitValue = rowsList.join('\n');
              values.push(
                dataFromAPI.elementName,
                splitValue === undefined
                  ? dataFromAPI.elementValue
                  : splitValue,
              );
            } else {
              splitValue = dataFromAPI.elementValue?.split('|');
              values.push(
                dataFromAPI.elementName,
                splitValue?.[1] === undefined
                  ? dataFromAPI.elementValue
                  : splitValue[1],
              );
            }
            data.push(values);
          }
        }
      });
    });

    // updatedFormDetails.forEach((d) => {
    //   let values = [];
    //   let splitValue = d.elementValue?.split('|');
    //   values.push(
    //     d.elementName,
    //     splitValue?.[1] === undefined ? d.elementValue : splitValue[1],
    //   );
    //   data.push(values);
    // });
    data.push(['TimeStamp', new Date()]);

    let content = {
      startY: 150,
      head: headers,
      body: data,
    };

    // doc.text(title, marginLeft, 40);
    autoTable(doc, content);
    doc.save(name + '.pdf');

    // const response = await agent.Files.uploadFile(doc.output('blob') as File);
  };

  const saveHandler = async (updatedFormDetails: any[]) => {
    try {
      if (!selectedValue && type === 'tableWithForm') {
        toast.info('Please select row in table');
        return;
      }

      let status = ``;
      let assetId = uuid();
      let payload = {
        assetId,
        components: updatedFormDetails?.map((data) => {
          /**
           * added symbols for replace the symbols with tag
           */
          status += `***${data.elementName}*** : ~~~${data.elementValue}~~~ \n`;
          // if (data.elementName === 'Select Asset') {
          //   assetNames = data.elementValue;
          // }
          // if (data.elementName === 'Receiving Date') {
          //   receivingDate = data.elementValue;
          // }
          // if (data.elementName === 'Return Date') {
          //   returnDate = data.elementValue;
          // }
          return {
            ...data,
            elementId: uuid(),
            elementValue:
              type === 'tableWithForm' && data.elementName === linkColumnName
                ? selectedValue
                : data.elementValue,
            options: data.options?.map((option: any) => ({
              ...option,
              optionId: uuid(),
            })),
          };
        }),
        linkName: selectedValue,
      };

      // ======== Communication Settings  =====
      await commSettingsForDynDash
        .showMaster(masterId as string)
        .then(async (Response) => {
          if (Response.data.length > 0) {
            await commSettingsForDynDash.showDynDashCommunication(
              assetId,
              Response?.data[0]?.masterId,
            );
          }
        });

      // ===========  AMTransactionReport  =========
      if (staticSelectedCard === 'Transaction') {
        const res = await agent.AssetRental.AMTransactionReport(
          masterId,
          payload,
        );
        assignUserMaster(res?.data, userStore?.user?.id);
      }

      let [result] = await Promise.all([
        commonStore.staticDemoChanges && staticSelectedCard === 'Transaction'
          ? null
          : await agent.newMasterReport.postMetadataList(payload, masterId),
        ((commonStore.staticDemoChanges &&
          name !== 'Raise Request' &&
          staticSelectedCard !== 'Transaction') ||
          !commonStore.staticDemoChanges) &&
          assignUserMaster([assetId], userStore?.user?.id),
      ]);

      if (
        result?.data ===
        `The scanned barcode(s) doesn't match with selected asset(s)`
      ) {
        toast.warning(
          `The scanned barcode(s) doesn't match with selected asset(s)`,
        );
      } else if (result?.data === `Asset not selected to scan`) {
        toast.warning(`Asset not selected to scan`);
      } else {
        toast.success('Form Saved Successfully');
        getForm();
        setIsTableUpdated(true);
        if (commonStore.staticDemoChanges) {
          let details = '';
          updatedFormDetails.forEach((data) => {
            if (data.mode !== 2) {
              if (data.elementType === 'Masters') {
                details +=
                  data.elementName +
                  ': ' +
                  data.elementValue?.split('|')?.[1] +
                  '<br />';
              } else {
                details +=
                  data.elementName + ': ' + data.elementValue + '<br />';
              }
            }
          });
          let master =
            name === 'Raise Request' ? 'Outward Request' : 'Rental Request';
          let mailBody = `Dear ${userStore?.user?.displayName},<br/>\u00A0 This is to notify you that the Asset ${master} is raised successfully.<br/><br/> ${details} <br/> Regards, <br/> info@honeycombmanager.com
    `;
          sendRespectiveEmail(
            '',
            '',
            // masterName || '',
            `Asset ${master} - Status update`,
            '',
            '',
            userStore?.user?.email,
            mailBody,
          );
        }
        if (automaticPdf) {
          if (commonStore.staticDemoChanges) {
            downloadPDF(updatedFormDetails, '/assets/LVPCMS.png');
          } else {
            downloadPDF(updatedFormDetails);
          }
        }
        let history = {
          historyId: uuid(),
          assetId,
          userId: user?.id || '',
          name: user?.displayName || '',
          department: user?.departmentName || '',
          imageUrl: user?.image || '',
          status,
          date: new Date().toISOString(),
        };
        await agent.newMasterReport.updateHistory(history);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div style={style} className="new-report-form-wrapper">
      <h4 style={{ color: '#3184d5' }}>{name}</h4>
      {!loader.content &&
        (formDetails?.length === 0 ? (
          <h4
            style={{
              letterSpacing: '.5px',
              marginTop: '0',
              color: 'grey',
            }}
          >
            {/* The form has been deleted. You will no longer be able to access this
            form or any of its submissions. */}
            Sorry, No data
          </h4>
        ) : (
          <FormComponentDyDb
            cancelBtnMode={cancelBtnMode}
            submitBtnMode={submitBtnMode}
            formDetails={formDetails}
            saveHandler={saveHandler}
            loader={loader}
            formName={name}
            linkColumnName={linkColumnName}
            linkColumnValue={selectedValue}
          />
        ))}
    </div>
  );
}

export default FormRegisterDyDB;
